module.exports = __webpack_public_path__ + "img/abs_calendar.21db0e27.png";